import gql from 'graphql-tag';

export const getAllSentNotificationsForContentCount = gql`
  query getAllSentNotificationsForContentCount($contentId: UUID!) {
    allSentNotificationsForContentCount(contentId: $contentId)
  }
`;
